import { defineMessages } from 'react-intl';

export default defineMessages({
  sorting: {
    id: 'wishlist.sorting.label',
    defaultMessage: 'Řazení',
  },
  addedRecentlySortOption: {
    id: 'wishlist.sorting.addedRecentlyOption',
    defaultMessage: 'Nedávno přidané',
  },
});
